import { Section } from 'app/models/types';
import { FieldNames } from 'app/models/fields/names';
import {
  COMMERCIAL_LEASE_EQUIPMENT_BUSINESS_INFO,
  COMMERCIAL_LEASE_EQUIPMENT_OWNER_INFO,
  COMMERCIAL_LEASE_EQUIPMENT_EQUIPMENT_INFO,
  COMMERCIAL_LEASE_EQUIPMENT_INSURANCE_INFO,
  COMMERCIAL_LEASE_EQUIPMENT_TRADE_REFERENCE_INFO,
  COMMERCIAL_LEASE_EQUIPMENT_SSN,
} from 'app/models/sections/constants';
import { getCommercialLeaseEquipmentQuestionsByName } from 'app/models/questions/commercial-lease-equipment';
import { SmallBusinessCollectSsnStep } from 'app/components/SmallBusinessCollectSsnStep';

export const getCommercialLeaseEquipmentSectionById = (id: number): Section => {
  return COMMERCIAL_LEASE_EQUIPMENT_SECTIONS.find((section) => section.id === id) as Section;
};

const COMMERCIAL_LEASE_EQUIPMENT_SECTIONS: Section[] = [
  {
    id       : COMMERCIAL_LEASE_EQUIPMENT_BUSINESS_INFO,
    title    : 'Tell us about your business',
    questions: getCommercialLeaseEquipmentQuestionsByName([
      FieldNames.commercialBusinessName,
      FieldNames.commercialBusinessStartDate,
      FieldNames.commercialStreet,
      FieldNames.commercialStreet2,
      FieldNames.commercialCity,
      FieldNames.commercialState,
      FieldNames.commercialZip,
      FieldNames.commercialBusinessCounty,
      FieldNames.commercialPhone,
      FieldNames.commercialBusinessEmail,
      FieldNames.commercialEntityType,
      FieldNames.commercialStateOfOrganization,
      FieldNames.commercialTIN,
      FieldNames.commercialDescription,
    ]),
  },
  {
    id       : COMMERCIAL_LEASE_EQUIPMENT_OWNER_INFO,
    title    : 'Tell us about the owners of the business',
    questions: getCommercialLeaseEquipmentQuestionsByName([
      FieldNames.commercialOwnerList,
    ]),
  },
  {
    id       : COMMERCIAL_LEASE_EQUIPMENT_EQUIPMENT_INFO,
    title    : 'Tell us about the equipment',
    questions: getCommercialLeaseEquipmentQuestionsByName([
      FieldNames.commercialEquipmentDescription,
      FieldNames.commercialExpectedCost,
      FieldNames.commercialEquipmentLocation,
      FieldNames.commercialSalesTaxExempt,
      FieldNames.commercialTaxExemptReason,
      FieldNames.commercialPropertyTaxExempt,
    ]),
  },
  {
    id       : COMMERCIAL_LEASE_EQUIPMENT_INSURANCE_INFO,
    title    : 'Tell us about your insurance',
    questions: getCommercialLeaseEquipmentQuestionsByName([
      FieldNames.insuranceCompanyName,
      FieldNames.insuranceCompanyStreet,
      FieldNames.insuranceCompanyStreet2,
      FieldNames.insuranceCompanyCity,
      FieldNames.insuranceCompanyState,
      FieldNames.insuranceCompanyZip,
      FieldNames.insuranceAgentFirstName,
      FieldNames.insuranceAgentMiddleName,
      FieldNames.insuranceAgentLastName,
      FieldNames.insuranceAgentSuffixName,
      FieldNames.insuranceAgentEmail,
      FieldNames.insuranceAgentPhone,
    ]),
  },
  {
    id       : COMMERCIAL_LEASE_EQUIPMENT_TRADE_REFERENCE_INFO,
    title    : 'Tell us about your trade reference',
    questions: getCommercialLeaseEquipmentQuestionsByName([
      FieldNames.tradeReferenceName,
      FieldNames.tradeReferenceStreet,
      FieldNames.tradeReferenceStreet2,
      FieldNames.tradeReferenceCity,
      FieldNames.tradeReferenceState,
      FieldNames.tradeReferenceZip,
      FieldNames.tradeReferencePhone,
      FieldNames.tradeReferenceEmail,
      FieldNames.tradeReferenceContact,
    ]),
  },
  {
    id            : COMMERCIAL_LEASE_EQUIPMENT_SSN,
    ifNoQuestions : SmallBusinessCollectSsnStep,
  },
];
